<template>
    <div class="flex gap-3">
        <Btn
            v-if="isOwner"
            data-testid="profile-get-karma-btn"
            :left-icon="screen.minMD ? 'badge-karma-full' : ''"
            :variant="BtnVariant.OUTLINED"
            color="purple-700"
            :size="BtnSize.SM"
            :label="screen.maxSM ? t('profile:show.karma_label_sm') : t('profile:show.karma_label')"
            class="w-full md:w-auto"
            @click="openKarmaPopup"
        />
        <Btn
            v-if="isOwner"
            data-testid="profile-get-rewards-btn"
            :href="route('reward.list')"
            :left-icon="screen.minMD ? 'badge-credit-full' : ''"
            :variant="BtnVariant.OUTLINED"
            color="orange-200"
            :size="BtnSize.SM"
            :label="screen.maxSM ? t('profile:show.credits_label_sm') : t('profile:show.credits_label')"
            class="w-full md:w-auto"
        />
        <Btn
            v-if="isLoggedIn && !isOwner"
            icon="chat"
            data-testid="chat-button_profile-page"
            :to="{ name: 'chats.user', params: { id: currentProfile.id } }"
            :title="t('chat.chatUserBtn')"
            :variant="BtnVariant.OUTLINED"
            :size="BtnSize.SM"
            class="text-slate-600"
        ></Btn>
        <BtnMenuShare
            :share-title="
                t('share.title', {
                    name: currentProfile.name,
                })
            "
            :share-url="shareUrl"
            :variant="BtnVariant.OUTLINED"
            size="sm"
        />
        <BtnMenu
            v-if="isOwner"
            ref="menuProfile"
            :tooltip-text="t('tooltip.menu')"
            menu-placement="bottom-end"
            menu-popover-size-class="max-w-2xs"
            :menu-title="t('profile:show.menu.options.header_settings')"
            left-icon="settings"
            :options="menuOptions"
            :size="BtnSize.SM"
            :variant="BtnVariant.OUTLINED"
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BtnSize, BtnVariant } from '@components/Btn';
import route from '@router/route';
import BtnMenuShare from '@/components/BtnMenuShare';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'ProfileShowMenu',
    components: {
        BtnMenuShare,
    },
    setup() {
        const { t } = useTranslation('profile');
        return { t };
    },
    data() {
        return {
            BtnVariant,
            BtnSize,
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            isProfileOwner: 'profile/isProfileOwner',
            currentProfile: 'profile/profile',
            isLoggedIn: 'auth/isLoggedIn',
        }),
        ...mapGetters('ui', ['screen']),
        shareUrl() {
            const userId = this.user ? this.user.userid : null;
            return route('profile.show', {
                id: this.currentProfile.id,
                slug: this.currentProfile.slug,
                ref: userId,
            });
        },
        isOwner() {
            return this.isProfileOwner(this.user);
        },
        menuOptions() {
            return [
                {
                    href: this.route('profile.edit'),
                    label: this.t('profile:show.menu.options.edit'),
                    icon: 'edit',
                },
                {
                    // IMPORTANT: With SDFE-642 we introduced permament redirects which made the page inaccessible to some users.
                    //   With `?` we can bust the browser cache and force the page to load the original URL.
                    href: `${this.$router.resolveWithDefaults({ name: 'profile.settings' }).value.href}?`,
                    label: this.t('profile:show.menu.options.settings'),
                    icon: 'settings',
                },
                {
                    onclick: this.logout,
                    label: this.t('profile:show.menu.options.logout'),
                    icon: 'logout',
                },
            ];
        },
    },
    methods: {
        route,
        ...mapActions('auth', ['logout']),
        openKarmaPopup() {
            this.$modal.open(defineAsyncComponent(() => import('@components/ModalExplainKarma')));
        },
    },
};
</script>
